import { RouteRecordRaw } from 'vue-router';
import { ORDER_ROUTE_NAME } from '@/libs/route-name';

export const orderRoute = (): RouteRecordRaw => ({
  path: '',
  name: ORDER_ROUTE_NAME.ORDERS,
  component: () => import('@/pages/order/index.vue'),
});

export const customerOrderRoute = (): RouteRecordRaw => ({
  path: '/order/customer/:id',
  name: ORDER_ROUTE_NAME.CUSTOMER_ORDERS,
  component: () => import('@/pages/order/customer-order.vue'),
});

export const orderDetailRoute = (): RouteRecordRaw => ({
  path: '/order/:id',
  name: ORDER_ROUTE_NAME.ORDER_DETAIL,
  component: () => import('@/pages/order/order-detail.vue'),
});

export const orderPackingRoute = (): RouteRecordRaw => ({
  path: '/order/:id/packing',
  name: ORDER_ROUTE_NAME.ORDER_PACKING,
  component: () => import('@/pages/order/order-packing.vue'),
});
